import React from 'react';

const MultiSelectIcon = ({ color = '#757575', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M1.66602 14.1673C1.66602 12.596 1.66602 11.8103 2.15417 11.3221C2.64233 10.834 3.428 10.834 4.99935 10.834H14.9993C16.5707 10.834 17.3564 10.834 17.8445 11.3221C18.3327 11.8103 18.3327 12.596 18.3327 14.1673C18.3327 15.7387 18.3327 16.5243 17.8445 17.0125C17.3564 17.5007 16.5707 17.5007 14.9993 17.5007H4.99935C3.428 17.5007 2.64233 17.5007 2.15417 17.0125C1.66602 16.5243 1.66602 15.7387 1.66602 14.1673Z"
        stroke="#757575"
        stroke-width="1.25"
      />
      <path
        d="M1.66602 4.99935C1.66602 3.428 1.66602 2.64233 2.15417 2.15417C2.64233 1.66602 3.428 1.66602 4.99935 1.66602H14.9993C16.5707 1.66602 17.3564 1.66602 17.8445 2.15417C18.3327 2.64233 18.3327 3.428 18.3327 4.99935C18.3327 6.5707 18.3327 7.35637 17.8445 7.84453C17.3564 8.33268 16.5707 8.33268 14.9993 8.33268H4.99935C3.428 8.33268 2.64233 8.33268 2.15417 7.84453C1.66602 7.35637 1.66602 6.5707 1.66602 4.99935Z"
        stroke="#757575"
        stroke-width="1.25"
      />
      <path d="M9.16602 5H14.9993" stroke="#757575" stroke-width="1.25" stroke-linecap="round" />
      <path d="M5 5H6.66667" stroke="#757575" stroke-width="1.25" stroke-linecap="round" />
      <path d="M9.16602 14.166H14.9993" stroke="#757575" stroke-width="1.25" stroke-linecap="round" />
      <path d="M5 14.166H6.66667" stroke="#757575" stroke-width="1.25" stroke-linecap="round" />
    </svg>
  );
};

export default React.forwardRef(MultiSelectIcon);
